import { render, staticRenderFns } from "./LoginAgainPage.vue?vue&type=template&id=dbca980e&scoped=true"
import script from "./LoginAgainPage.vue?vue&type=script&lang=js"
export * from "./LoginAgainPage.vue?vue&type=script&lang=js"
import style0 from "./LoginAgainPage.vue?vue&type=style&index=0&id=dbca980e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbca980e",
  null
  
)

export default component.exports